import {
	Component,
	OnInit,
	Input,
	Output,
	ViewEncapsulation,
	EventEmitter,
	ViewChild,
	ElementRef,
	AfterViewInit,
	ContentChild,
	OnChanges,
	ChangeDetectorRef
} from "@angular/core";
import { IdService } from "../shared/services/id.service";

import { TopNavItem } from "./topnav.interface";

@Component({
	selector: "rbc-top-nav",
	templateUrl: "./topnav.component.html",
	encapsulation: ViewEncapsulation.None
})
export class TopnavComponent implements OnInit, AfterViewInit, OnChanges {
	showSearch = false;
	showItems;

	@Input() id: string;
	@Input() fullWidth = true;
	@Input() logo: string;
	@Input() logoLink: string;
	@Input() logoLabel = "Logo";
	@Input() searchPlaceholder;
	@Input() search: Function | boolean;
	@Input() items: TopNavItem[];
	@Input() logoRouter;
	show = true;

	@Input() set showSecondary (val){
		this.show = val;
	}

	get showSecondary(){
		return this.show;
	}

	@Output() buttonClick = new EventEmitter();
	@Output() onSearch = new EventEmitter();

	query = "";

	@ViewChild("secondaryContainer", { static: false })
	secondaryContainer: ElementRef;
	@ViewChild("secondaryLeftRef", { static: false })
	secondaryLeftRef: ElementRef;
	@ViewChild("secondaryRef", { static: false }) secondaryRef: ElementRef;

	@ContentChild("navItems", { static: false }) navItems: ElementRef;
	constructor(private idService: IdService, private cdr: ChangeDetectorRef) { }

	ngOnInit() {
		this.showSearch = this.onSearch.observers.length > 0;
		if (!this.id) {
			this.id = this.idService.generate();
		}

		if (!this.searchPlaceholder) {
			this.searchPlaceholder = "Search";
		}
	}

	ngAfterViewInit() {
		if(this.secondaryLeftRef && this.secondaryRef){
			if(this.secondaryLeftRef.nativeElement.children.length === 0 && this.secondaryRef.nativeElement.children.length === 0 ){
				this.showSecondary = false;
				this.cdr.detectChanges();
			}
		}
		if (this.navItems) {
			this.showItems = true;
			this.cdr.detectChanges();
		}
	}

	ngOnChanges(e){
		if(e.showSecondary){
			if(e.showSecondary.currentValue){
				document.body.classList.add("nav-has-secondary");
			} else {
				document.body.classList.remove("nav-has-secondary");
			}
		}
	}

	onInputSearch(e) {
		if (e) {
			this.onSearch.emit(e);
		}
	}

	isVisible(item) {
		return typeof item.visible === "undefined";
	}

	$_TopNav_search() {
		if (typeof this.search === "function") {
			this.search(this.query);
		}
	}

	topNavButtonClick(event) {
		console.log("test");
	}
}
